"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLanguageSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var useCallbackFactory_1 = require("powerhooks/useCallbackFactory");
var useConstCallback_1 = require("powerhooks/useConstCallback");
var ThemeProvider_1 = require("./lib/ThemeProvider");
var Icon_1 = require("./Icon");
var TextBase_1 = require("./Text/TextBase");
var useDomRect_1 = require("powerhooks/useDomRect");
var Tooltip_1 = require("./Tooltip");
var Button_1 = __importDefault(require("@mui/material/Button"));
var Menu_1 = __importDefault(require("@mui/material/Menu"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var objectKeys_1 = require("tsafe/objectKeys");
var Public_1 = __importDefault(require("@mui/icons-material/Public"));
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
var Icon = Icon_1.createIcon({
    "public": Public_1.default,
    "expandMore": ExpandMore_1.default,
}).Icon;
var menuId = "language-menu";
function createLanguageSelect(params) {
    var languagesPrettyPrint = params.languagesPrettyPrint;
    var LanguageSelect = react_1.memo(function (props) {
        var className = props.className, _a = props.doShowIcon, doShowIcon = _a === void 0 ? true : _a, variant = props.variant, changeLanguageText = props.changeLanguageText, language = props.language, onLanguageChange = props.onLanguageChange;
        var _b = useDomRect_1.useDomRect(), buttonRef = _b.ref, buttonWidth = _b.domRect.width;
        var _c = useStyles({ buttonWidth: buttonWidth, variant: variant }), classes = _c.classes, theme = _c.theme, cx = _c.cx, css = _c.css;
        var _d = __read(react_1.useState(undefined), 2), languageMenu = _d[0], setLanguageMenu = _d[1];
        var onClick = useConstCallback_1.useConstCallback(function (event) {
            return setLanguageMenu(event.currentTarget);
        });
        var onMenuClose = useConstCallback_1.useConstCallback(function () { return setLanguageMenu(undefined); });
        var onMenuItemClickFactory = useCallbackFactory_1.useCallbackFactory(function (_a) {
            var _b = __read(_a, 1), lng = _b[0];
            onLanguageChange(lng);
            onMenuClose();
        });
        return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(Tooltip_1.Tooltip, __assign({ title: changeLanguageText, enterDelay: 300 }, { children: jsx_runtime_1.jsxs(Button_1.default, __assign({ className: cx(classes.button, className), ref: buttonRef, "aria-owns": languageMenu ? menuId : undefined, "aria-haspopup": "true", "aria-label": changeLanguageText !== null && changeLanguageText !== void 0 ? changeLanguageText : "change language", onClick: onClick, "data-ga-event-category": "header", "data-ga-event-action": "language" }, { children: [doShowIcon && (jsx_runtime_1.jsx(Icon, { iconId: "public", className: classes.icon, size: (function () {
                                    switch (variant) {
                                        case "big":
                                            return "default";
                                        case "small":
                                            return "extra small";
                                    }
                                })() }, void 0)),
                            jsx_runtime_1.jsx(TextBase_1.Text, __assign({ typo: (function () {
                                    switch (variant) {
                                        case "big":
                                            return "label 1";
                                        case "small":
                                            return "body 2";
                                    }
                                })(), className: css({
                                    "marginLeft": theme.spacing(2),
                                    "textTransform": "capitalize",
                                }) }, { children: languagesPrettyPrint[language] }), void 0),
                            variant === "big" && (jsx_runtime_1.jsx(Icon, { className: classes.icon, iconId: "expandMore" }, void 0))] }), void 0) }), void 0),
                jsx_runtime_1.jsx(Menu_1.default, __assign({ id: menuId, anchorEl: languageMenu, open: languageMenu !== undefined, className: classes.menu, onClose: onMenuClose }, { children: objectKeys_1.objectKeys(languagesPrettyPrint)
                        .sort(function (a, b) {
                        return a === language ? -1 : b === language ? 1 : 0;
                    })
                        .map(function (supportedLanguage) { return (jsx_runtime_1.jsx(MenuItem_1.default, __assign({ component: "a", "data-no-link": "true", selected: language === supportedLanguage, onClick: onMenuItemClickFactory(supportedLanguage), lang: supportedLanguage }, { children: languagesPrettyPrint[supportedLanguage] }), supportedLanguage)); }) }), void 0)] }, void 0));
    });
    var useStyles = ThemeProvider_1.makeStyles({ "name": { LanguageSelect: LanguageSelect } })(function (theme, _a) {
        var buttonWidth = _a.buttonWidth, variant = _a.variant;
        return ({
            "button": {
                "padding": (function () {
                    switch (variant) {
                        case "big":
                            return undefined;
                        case "small":
                            return 0;
                    }
                })(),
            },
            "menu": {
                "& .Mui-selected": {
                    "backgroundColor": theme.colors.useCases.surfaces.surface1,
                },
                "& .MuiPaper-root": {
                    "backgroundColor": theme.colors.useCases.surfaces.background,
                    "width": (function () {
                        switch (variant) {
                            case "big":
                                return buttonWidth;
                            case "small":
                                return undefined;
                        }
                    })(),
                },
                "& a": {
                    "color": theme.colors.useCases.typography.textPrimary,
                },
            },
            "icon": {
                "color": theme.colors.useCases.typography.textPrimary,
            },
        });
    });
    return { LanguageSelect: LanguageSelect };
}
exports.createLanguageSelect = createLanguageSelect;
//# sourceMappingURL=LanguageSelect.js.map